import React from 'react';
import { withRouter } from 'react-router';
import ScrollDebugPanel from '../../pages/inspection/ScrollDebugPanel';
import styles from './style.module.scss';

class EmbeddedLayout extends React.PureComponent {
  render() {
    const { children, location } = this.props;
    const showDebug = new URLSearchParams(location.search).get('debug') === '1';

    return (
      <div className={styles.embeddedWrapper}>
        {children}
        {showDebug && <ScrollDebugPanel />}
      </div>
    );
  }
}

export default withRouter(EmbeddedLayout);
